import './style.sass';

import ScrollAnimation from 'core/ScrollAnimation';
type CrewItemPropsType = {
    crewItemTitle: string;
    crewItemSubtitle?: string;
};
const CrewItem = ({ crewItemTitle, crewItemSubtitle }: CrewItemPropsType) => {
    return (
        <ScrollAnimation
            animateIn="fadeInUp"
            offset={50}
            delay={100}
            animateOnce={true}
            duration={1}
            className="crew__list-item"
        >
            <div className="crew__list-info">
                <div className="crew__list-title">{crewItemTitle}</div>
                {crewItemSubtitle && <div className="crew__list-subtitle">{crewItemSubtitle}</div>}
            </div>
        </ScrollAnimation>
    );
};

export default CrewItem;
